import React from 'react';
import { Navigate } from 'react-router-dom';

import { useCustomTranslation, useStoreSelector } from '../../../helpers/hooks';
import PaymentInitialization from '../../PaymentInitialization';

import { InvoiceCommonResult } from './types/common';
import { SantraPayResult } from './types/santraPay';
import { MontenexResult } from './types/montenex';
import { WeChatResult } from './types/weChat';

import { ErrorBlock } from '../../Block';
import ErrorBoundary from '../../ErrorBoundary';

const resultTypes = {
  COMMON: 1,
  TEMPLATES: 2,
};

const templates = {
  SANTRA_PAY: '1',
  WE_CHAT: '2',
  MONTENEX: '3',
};

export default function InvoiceResult() {
  const { urlFor, t } = useCustomTranslation();

  const invoice = useStoreSelector((selector) => {
    try {
      return selector.getInvoice();
    } catch (e) {}
  });

  if (!invoice.result.initialized) {
    return (
      <PaymentInitialization>
        <Navigate to={urlFor('payMethodSelector')} />
      </PaymentInitialization>
    );
  }

  let result;
  switch (invoice.result.type) {
    case resultTypes.COMMON: {
      result = <InvoiceCommonResult invoice={invoice} />;
      break;
    }
    case resultTypes.TEMPLATES: {
      switch (String(invoice.result.data.template)) {
        case templates.SANTRA_PAY: {
          result = <SantraPayResult invoice={invoice} />;
          break;
        }
        case templates.MONTENEX: {
          result = <MontenexResult invoice={invoice} />;
          break;
        }
        case templates.WE_CHAT: {
          result = <WeChatResult invoice={invoice} />;
          break;
        }
        default: {
          result = <ErrorBlock headerText={t('DefaultError')} />;
        }
      }

      break;
    }
    default: {
      result = <InvoiceCommonResult invoice={invoice} />;
    }
  }

  return (
    <ErrorBoundary
      fallback={<ErrorBlock headerText={t('DefaultError')} />}
      severity={'error'}
    >
      {result}
    </ErrorBoundary>
  );
}
